module.exports = __webpack_public_path__ + "static/16-f761652407ff3b249054ff4e29d684ad.jpg";